import request from '@/utils/request'

let OarcouponApi = {
  /*满送活动列表*/
  list(data) {
    return request._post('/shop/plus.oarcoupon.Index/index', data);
},
/*添加满送活动*/
add(data) {
    return request._post('/shop/plus.oarcoupon.Index/add', data);
},
/*修改满送活动*/
edit(data) {
    return request._post('/shop/plus.oarcoupon.Index/edit', data);
},
/*删除满送活动*/
del(data) {
    return request._post('/shop/plus.oarcoupon.Index/del', data);
},
/*满送活动详情*/
detail(data) { 
  return request._post('/shop/plus.oarcoupon.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.oarcoupon.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.oarcoupon.Setting/getSetting', data, errorback);
    },
    editPart(data) {
        return request._post('/shop/plus.oarcoupon.Index/editPart', data);
    },
}
export default OarcouponApi;



// WEBPACK FOOTER //
// ./src/api/oarcoupon.js